import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from '../../sessions/components/SessionDialog'

const TextArea = styled.textarea`
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  margin-bottom: 12px;
`
const SeverityRow = styled.div`
  display: flex;
  gap: 8px;
`
const Pill = styled.button`
  appearance: none;
  border: 1px solid
    ${(p) =>
      p.$active ? p.theme?.color?.primary || '#1F3A5F' : p.theme?.color?.border || '#E6E0D6'};
  background: ${(p) =>
    p.$active ? p.theme?.color?.primarySoft || '#E8EEF6' : 'transparent'};
  border-radius: 999px;
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
`

export default function SideEffectDialog({ open, medicineName, onClose, onSubmit }) {
  const [description, setDescription] = useState('')
  const [severity, setSeverity] = useState('MILD')
  const [busy, setBusy] = useState(false)

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({ description: description.trim(), severity })
      setDescription('')
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title="Log a side effect"
      subtitle={medicineName ? `For ${medicineName}.` : null}
      primaryLabel="Save"
      primaryDisabled={!description.trim()}
      primaryLoading={busy}
      onPrimary={handleSubmit}
      onClose={onClose}
    >
      <TextArea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Describe what you're noticing"
      />
      <SeverityRow>
        {['MILD', 'MODERATE', 'SEVERE'].map((s) => (
          <Pill key={s} $active={severity === s} onClick={() => setSeverity(s)}>
            {s.charAt(0) + s.slice(1).toLowerCase()}
          </Pill>
        ))}
      </SeverityRow>
    </SessionDialog>
  )
}
